import get from 'lodash/get'

export default {
    methods: {
        featureFlag(value) {
            return get(window.Portal.featureFlags, value)
        }
    }
}
